import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { UniversalLink } from '@plone/volto/components';

import useDiscoveryLinks from './useDiscoveryLinks';
import { tagSearchPath } from './utils';

const ageLinks = [
  { label: '3-4歳', tag: '3-4歳' },
  { label: '5-6歳', tag: '5-6歳' },
  { label: '小学生', tag: '小学生' },
];

const topicLinks = [
  { label: '英語絵本', tag: '英語絵本' },
  { label: '読み聞かせ', tag: '読み聞かせ' },
  { label: '図書館本', tag: '図書館本' },
  { label: '家庭学習', tag: '家庭学習' },
  { label: '娘のお気に入り', tag: '娘のお気に入り' },
];

const featuredArticleLinks = [
  {
    href: '/articles/qactey',
    title: '小１娘、そろばんを習っています。',
    meta: '家庭学習',
  },
  {
    href: '/articles/adw1df',
    title: '小１娘のそろばん近況',
    meta: '家庭学習',
  },
  {
    href: '/articles/gm8g8k',
    title: 'ORTのセットをメルカリで購入しました。',
    meta: '英語絵本',
  },
  {
    href: '/articles/b2j5ne',
    title: 'フードバンクを知る絵本',
    meta: '図書館本',
  },
];

const SiteHomeView = (props) => {
  const { content } = props;
  const discoveryLinks = useDiscoveryLinks();

  return (
    <main className="ehon-home">
      <section className="ehon-hero">
        <Container>
          <div className="ehon-hero-title-pane">
            <img
              className="ehon-hero-icon"
              src="/blog-icon.svg/@@images/image"
              alt=""
            />
            <div>
              <p className="ehon-kicker">子どもと本を読む毎日の記録</p>
              <h1>{content.title || '絵本ヶ原で待ち合わせ'}</h1>
            </div>
          </div>
          <p className="ehon-lead">
            娘と実際に読んだ絵本・児童書・英語絵本・家庭学習の記録を、
            本選びに迷う親へ届く形でまとめています。
          </p>
          <div className="ehon-discovery-panel">
            <form
              action="/articles/search"
              aria-label="キーワードで記事を探す"
              className="ehon-search-form"
              method="get"
            >
              <input
                name="SearchableText"
                placeholder="本の題名・年齢・テーマで検索"
                type="search"
              />
              <button type="submit">検索</button>
            </form>
            <div className="ehon-discovery-links" aria-label="タグで記事を探す">
              {discoveryLinks.map((link) => (
                <UniversalLink
                  href={tagSearchPath(link.tag)}
                  key={link.label}
                >
                  #{link.label}
                </UniversalLink>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <Container className="ehon-home-body">
        <section className="ehon-start" aria-label="記事の探し方">
          <div className="ehon-start-header">
            <p className="ehon-section-label">Start here</p>
            <h2>気になる入口から読む</h2>
          </div>
          <div className="ehon-start-grid">
            <nav className="ehon-start-group" aria-label="年齢で探す">
              <h3>年齢</h3>
              <div className="ehon-pill-list">
                {ageLinks.map((link) => (
                  <UniversalLink href={tagSearchPath(link.tag)} key={link.tag}>
                    {link.label}
                  </UniversalLink>
                ))}
              </div>
            </nav>
            <nav className="ehon-start-group" aria-label="テーマで探す">
              <h3>テーマ</h3>
              <div className="ehon-pill-list">
                {topicLinks.map((link) => (
                  <UniversalLink href={tagSearchPath(link.tag)} key={link.tag}>
                    {link.label}
                  </UniversalLink>
                ))}
              </div>
            </nav>
            <nav className="ehon-start-group ehon-start-group-wide" aria-label="よく読まれている記事">
              <h3>よく読まれている記事</h3>
              <div className="ehon-featured-links">
                {featuredArticleLinks.map((link) => (
                  <UniversalLink href={link.href} key={link.href}>
                    <span>{link.meta}</span>
                    {link.title}
                  </UniversalLink>
                ))}
              </div>
            </nav>
          </div>
        </section>
        <RenderBlocks {...props} />
      </Container>
    </main>
  );
};

SiteHomeView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
};

export default SiteHomeView;
